// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DateRangePicker_picker {\n    z-index: 20;\n}\n*, *::before, *::after {\n    box-sizing: border-box;\n}", "",{"version":3,"sources":["webpack://../../@visma/formula/src/configToSchemas/types/dateRange/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B","sourcesContent":[".DateRangePicker_picker {\n    z-index: 20;\n}\n*, *::before, *::after {\n    box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
